
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/node--letter",
      function () {
        return require("private-next-pages/node--letter/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/node--letter"])
      });
    }
  